import React, { useEffect, useState } from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import styles from "./OperatingCompany.module.css";
const OperatingCompany = () => {
  return (
    <>
      <Header />
      <div className={styles.main_div}>
        <div className={styles.heading}>運営会社</div>
        <div className={styles.box}>
          <div className={styles.box_inner}>
            <div className={styles.inner_div_wrapper}>
              <div className={styles.inner_div1}>社　名</div>
              <div className={styles.inner_div2}>株式会社ブルースカイ</div>
            </div>
            <div className={styles.inner_div_wrapper}>
              <div className={styles.inner_div1}>本　社</div>
              <div className={styles.inner_div2}>〒810-0021</div>
            </div>
            <div className={styles.inner_div_wrapper}>
              <div className={styles.inner_div1}></div>
              <div className={styles.inner_div2}>
                福岡市中央区今泉2-5-24権藤ビル303
              </div>
            </div>
            <div className={styles.inner_div_wrapper}>
              <div className={styles.inner_div1}>資本金</div>
              <div className={styles.inner_div2}>1,700万円</div>
            </div>
            <div className={styles.inner_div_wrapper}>
              <div className={styles.inner_div1}>代表者</div>
              <div className={styles.inner_div2}>代表取締役 貞末真吾</div>
            </div>
            <div className={styles.inner_div_wrapper}>
              <div className={styles.inner_div1}>URL:</div>
              <div className={styles.inner_div2}>http://bluesky2012.com/</div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default OperatingCompany;
